import { IntegrationEnum } from 'models/InternalIntegrationSetting';

export const IntegrationsTab = {
  all: 'all',
  featured: 'featured',
  payments: 'payments',
  dynamicPricing: 'dynamic-pricing',
  homeAutomation: 'home-automation',
  cleaningAndTurnover: 'cleaning-and-turnover',
  accounting: 'accounting',
  insuranceAndScreening: 'insurance-and-screening',
  digitalSignatures: 'digital-signatures',
  customWebsites: 'custom-websites',
  brandManagement: 'brand-management',
  listingTools: 'listing-tools',
  analyticsTools: 'analytics-tools',
  guestExperience: 'guest-experience',
  reviews: 'reviews',
  imageCompression: 'image-compression',
  workflowAutomations: 'workflow-automations',
  communications: 'communications',
  industryOrganizations: 'industry-organizations',
};

export const integrationsTabSidePanelId = 'integrations-tab-side-panel';

export type IntegrationsTabType =
  (typeof IntegrationsTab)[keyof typeof IntegrationsTab];

export enum IntegrationsBadgeFilter {
  WITH_BADGES = 'WITH_BADGES',
  WITHOUT_BADGES = 'WITHOUT_BADGES',
}

export const INTEGRATIONS_REQUIRING_SHARE_GUEST_INFO = [
  IntegrationEnum.AIPEX,
  IntegrationEnum.AKIA,
  IntegrationEnum.AUTOHOST,
  IntegrationEnum.BREEZEWAY,
  IntegrationEnum.CHARGEAUTOMATION,
  IntegrationEnum.CHEKIN,
  IntegrationEnum.CLEARING,
  IntegrationEnum.CLYN,
  IntegrationEnum.DTRAVEL,
  IntegrationEnum.ENSO,
  IntegrationEnum.GETHOSTAI,
  IntegrationEnum.GUEST_GURU,
  IntegrationEnum.HOSTBUDDY_AI,
  IntegrationEnum.HOSTFI,
  IntegrationEnum.HOSTFULLY,
  IntegrationEnum.HOSTKIT,
  IntegrationEnum.LASOH,
  IntegrationEnum.LINKBASE,
  IntegrationEnum.MAILCHIMP,
  IntegrationEnum.MINUT,
  IntegrationEnum.NOSHABLE,
  IntegrationEnum.OK2CHARGE,
  IntegrationEnum.PRIMEHOST,
  IntegrationEnum.RESORTCLEANING,
  IntegrationEnum.REVA,
  IntegrationEnum.SAFELY,
  IntegrationEnum.TEXTREQUEST,
  IntegrationEnum.TRUVI,
  IntegrationEnum.VIRTUALKEY,
  IntegrationEnum.VRPLATFORM,
  IntegrationEnum.WYND,
  IntegrationEnum.YADA,
  IntegrationEnum.HOSTFULLYDEVICES,
  IntegrationEnum.NOISEAWARE,
  IntegrationEnum.TURNOVERBNB,
  IntegrationEnum.VRSCHEDULER,
];

export const INTEGRATIONS_WITH_CUSTOM_ACTIVATION_MODAL = [
  IntegrationEnum.MAILCHIMP,
  IntegrationEnum.TINYPNG,
  IntegrationEnum.HELLOSIGN,
  IntegrationEnum.POINTCENTRAL,
  IntegrationEnum.VACATIONRENTPAYMENT,
] as const;
